export class StepContainer{

    public index: number;
    public label: string;
    public disabled: boolean;
  }
  